import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import { BASE_URL, TRANSFER, WITHDRAW, M_POST } from '@/utils/api';

@Module({ name: 'balance' })
export default class Balance extends VuexModule {
  @Action({ rawError: true })
  async Refill(param: Record<string, unknown>) {
    try {
      const type = String((param as { type?: unknown }).type ?? '');
      const path = type === 'TRANSFER' ? TRANSFER : WITHDRAW;

      const { data } = await axios({
        url: BASE_URL + path,
        data: param,
        method: M_POST
      });

      assertOk(data, 'Refill failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Refill failed');
    }
  }
}
